'use client'
import { articleItemType } from '@/lib/article/server'
import { handleUserBehavior } from '@/lib/user_behavior/client'
import useImpressionObserver from '@/lib/user_behavior/use_impression_observer'
import Link from 'next/link'

type ScrollListProps = {
  items: articleItemType[]
  isSlider?: boolean
  bottom?: boolean
}

export const ScrollList: React.FC<ScrollListProps> = ({
  items,
  isSlider,
  bottom,
}) => {
  const sortedItems = items
    .sort((a, b) => a.display - b.display)
    .filter((item) => item.stock)
  const soldOutItems = items.filter((item) => !item.stock)
  const allItems = [...sortedItems, ...soldOutItems]

  const ItemCard = ({ item }: { item: articleItemType }) => {
    const ref = useImpressionObserver(item.item_id, item.price)

    return (
      <Link
        ref={ref}
        href={`/item/${item.item_id}`}
        className="relative"
        onClick={() => {
          void handleUserBehavior(item.item_id, 'click', item.price)
        }}
      >
        <div className="w-[150px] h-[150px]">
          <img
            src={item.image_url}
            alt={item.name}
            className="w-full"
            width={150}
            height={150}
            style={{
              maxHeight: '150px',
              maxWidth: '150px',
              verticalAlign: 'middle',
              objectFit: 'cover',
            }}
          />
        </div>
        <div
          className="w-[150px] bg-white text-left p-2"
          style={{
            fontSize:
              '"Source Sans Pro", Helvetica, Arial, 游ゴシック体, YuGothic, メイリオ, Meiryo, sans-serif',
          }}
        >
          <p className="text-lg font-bold">
            ¥{item.price.toLocaleString()}
            <span className="text-xs font-light"> (税込)</span>
          </p>
          {!item.stock && <p className="text-xs text-red-500">在庫切れ</p>}
          <p className="text-xs max-h-[34px] overflow-hidden">{item.name}</p>
        </div>
      </Link>
    )
  }

  return (
    <div className="scroll-list">
      <div className="mb-4">
        <h3
          className="font-lg font-semibold pl-1 pb-2"
          style={{ borderBottom: '1px solid #ededed' }}
        >
          {bottom ? '今回紹介した商品一覧' : '今回紹介する商品一覧'}
        </h3>
      </div>
      {isSlider ? (
        <div className="flex" style={{ overflowX: 'auto' }}>
          {allItems.map((item) => (
            <div key={item.item_id} className="w-1/2 p-2">
              <ItemCard item={item} />
            </div>
          ))}
        </div>
      ) : (
        // グリッド表示（縦2列）
        <div className="grid grid-cols-2 gap-2">
          {allItems.map((item) => (
            <div key={item.item_id} className="p-2">
              <ItemCard item={item} />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
